import type { ChronologyVersion } from "@/components/MedicalChronology/types";
import { CASE_STATUS, MedChronVersionStatus } from "@/constants";

/** Keeps user selection on refetch when still valid; otherwise falls back to current or first version. */
export const resolveSelectedVersionIdAfterFetch = (
  versions: ChronologyVersion[],
  previousId: string | null
): string | null => {
  if (versions.length === 0) return null;
  if (previousId && versions.some((v) => v.version_id === previousId)) {
    return previousId;
  }
  const current = versions.find((v) => v.is_current);
  return current?.version_id ?? versions[0]?.version_id ?? null;
};

/** True when the API will fork targetVersion on edit: a finished case's current human_reviewed version. */
export const isEditForkingFinishedVersion = (
  caseStatusId: number | null,
  targetVersion: ChronologyVersion | null
): boolean =>
  caseStatusId === CASE_STATUS.FINISHED &&
  targetVersion !== null &&
  targetVersion.is_current &&
  targetVersion.status === MedChronVersionStatus.HUMAN_REVIEWED;
